/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Base_User_Form_Firstname_Label1Inputs */

const en_base_user_form_firstname_label1 = /** @type {(inputs: Base_User_Form_Firstname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First Name`)
};

const de_base_user_form_firstname_label1 = /** @type {(inputs: Base_User_Form_Firstname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorname`)
};

/**
* | output |
* | --- |
* | "First Name" |
*
* @param {Base_User_Form_Firstname_Label1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const base_user_form_firstname_label1 = /** @type {((inputs?: Base_User_Form_Firstname_Label1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Base_User_Form_Firstname_Label1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_base_user_form_firstname_label1(inputs)
	return en_base_user_form_firstname_label1(inputs)
});
export { base_user_form_firstname_label1 as "base_user_form_firstName_label" }